module.exports = __webpack_public_path__ + "static/media/img-entregues-pqdosprincipes-04.40002475.jpg";